// @flow
import React from 'react';
import {headings} from '../../utils/constants';
import './styles.css';

// Type definitions
import type {Rows} from '../../utils/types';

type Props = {
  rows: Rows
};

export default function Table({ rows = [] }: Props) {
  return (
    <div className="Table">
      <table className="Table__contents">
        <thead>
          <tr>
            {
              headings.map((heading, index) => (
                <th key={index}>{heading}</th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {
                  row.map((col, colIndex) => (
                    <td key={colIndex}>{col}</td>
                  ))
                }
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  );
}
